import { onAttach, onDetach } from '../attach';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';
import { UIView, UIViewSpec } from '../view';

export interface UICarouselOptions {
    classes?: UIClassesSpec;
    auto_slide?: boolean;
}

export class UICarousel extends UIView {
    constructor(items: UIViewSpec[], options: UICarouselOptions = {}) {
        super('div', ['ui-carousel', options.classes]);

        const views: UIViewSpec[] = [...items];

        for(let i = 0; i < 3; i++) {
            for(const p of items) {
                views.push(p.ui_elem.cloneNode(true));
            }
        }

        this.ui_add($el.DIV('r-scrolled', views));

        let started = false;
        let requesting = false;
        let last_scroll = 0;
        let loop_width = 0;

        const scroll_handler = () => {
            const scroll = this.ui_elem.scrollLeft;

            if(scroll < loop_width)
                this.ui_elem.scrollLeft = scroll + loop_width;
            else if(scroll > 3 * loop_width)
                this.ui_elem.scrollLeft = scroll - loop_width;
        }

        const animation_frame = () => {
            let scroll = this.ui_elem.scrollLeft;
            if(Math.abs(last_scroll - scroll) < 1.5)
                scroll = last_scroll;
            scroll += 0.25;

            if(scroll > 3 * loop_width)
                scroll -= loop_width;
            else if(scroll < loop_width)
                scroll += loop_width;

            this.ui_elem.scrollLeft = scroll;
            last_scroll = scroll;

            if(started)
                requestAnimationFrame(animation_frame);
            else
                requesting = false;
        }

        onAttach(this, () => {
            if(started) return;
            started = true;

            const el = this.ui_elem;
            loop_width = el.scrollWidth / 4;
            el.scrollLeft = 2 * loop_width;

            if(!requesting) {
                requesting = true;
                if(options.auto_slide) {
                    requestAnimationFrame(animation_frame);
                } else {
                    el.addEventListener('scroll', scroll_handler);
                }
            }
        });

        onDetach(this, () => {
            if(!started) return;
            started = false;
            if(!options.auto_slide && requesting) {
                requesting = false;
                this.ui_elem.removeEventListener('scroll', scroll_handler);
            }
        })
    }
}
